<template>
  <AdminEmployeesPage />
</template>

<script setup lang="ts">
import { useSeoMeta } from "@unhead/vue";
import AdminEmployeesPage from "shared-ui/pages/AdminEmployeesPage.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("admin_employees.title"),
});

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
